import React, { useEffect } from "react";

interface Props {
  src: string;
  onClose: () => void;
}

export default function ImageLightbox({ src, onClose }: Props) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed", inset: 0,
          background: "rgba(0,0,0,0.85)",
          backdropFilter: "blur(6px)",
          zIndex: 2000,
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "zoom-out",
          animation: "fadeIn 0.15s ease",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: 16, right: 20,
            background: "rgba(255,255,255,0.15)", border: "none",
            borderRadius: "50%", width: 40, height: 40,
            color: "#fff", fontSize: "1.1rem", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            backdropFilter: "blur(4px)",
          }}
          title="Kapat (Esc)"
        >
          <i className="bi bi-x-lg"></i>
        </button>

        <img
          src={src}
          alt="büyük görünüm"
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "90vw", maxHeight: "88vh",
            borderRadius: 12,
            boxShadow: "0 24px 80px rgba(0,0,0,0.6)",
            cursor: "default",
            objectFit: "contain",
          }}
        />

        <a
          href={src}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute", bottom: 20, left: "50%", transform: "translateX(-50%)",
            background: "rgba(255,255,255,0.15)", backdropFilter: "blur(4px)",
            border: "none", borderRadius: 20, padding: "6px 16px",
            color: "#fff", fontSize: "0.8rem", textDecoration: "none",
            display: "flex", alignItems: "center", gap: 6,
          }}
        >
          <i className="bi bi-box-arrow-up-right"></i> Yeni sekmede aç
        </a>
      </div>

      <style>{`@keyframes fadeIn { from { opacity:0 } to { opacity:1 } }`}</style>
    </>
  );
}
